import {NavLink} from "react-router-dom";
import {useTranslation} from "react-i18next";
import "./Menu.css";
import {useCallback, useEffect, useState} from "react";
import {node, nodes} from "../../utils/selector";
import MobileMenu from "./mobileMenu";
import isInViewport from "../../utils/viewport";
import {Col, NavLink as NavLinkR, Row} from "reactstrap";
import ContactModal from "../ContactModal";

export const Menu = () => {
    const {i18n, t} = useTranslation();

    const [isShown, setIsShown] = useState(true);
    const [isMobileShown, setIsMobileShown] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const menuHeader2 = node(".menu-header2");
            const nav = node("nav");
            setIsShown(
                isInViewport(menuHeader2, nav.getBoundingClientRect().height * 3)
            );
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const funcLang = useCallback((e: MouseEvent, key: string) => {
        i18n.changeLanguage(key);
        e.preventDefault();
        e.stopPropagation();
    }, [i18n]);

    useEffect(() => {
        if (!isShown) {
            const nav = node("nav");
            const cloneNav = nav.cloneNode(true);
            const container = node("div.container");
            (cloneNav as Element).classList.add("scrolled");
            container.appendChild(cloneNav);

            const langAnchors = nodes("nav.scrolled a.lang");
            langAnchors.forEach((langAnchor) => {
                langAnchor.addEventListener("click", (e) =>
                    funcLang(e as any, langAnchor.id)
                );
            });

            const mMenuBtn = node("nav.scrolled .m-menu-btn");
            mMenuBtn?.addEventListener("click", () => {
                setIsMobileShown((prev) => !prev);
            });
            const mMenuBtnClose = node("nav.scrolled .m-menu-btn-close");
            mMenuBtnClose?.addEventListener("click", () => {
                setIsMobileShown(false);
            });
        } else {
            const clone = node("nav.scrolled");
            if (clone) {
                clone.classList.add("unscrolled");
                setTimeout(() => clone.remove(), 200);
            }
        }
    }, [isShown, funcLang]);

    useEffect(() => {
        document.body.style.overflowY = isMobileShown ? "hidden" : "auto";
    }, [isMobileShown]);

    const [showModal, setShowModal] = useState(false);

    return (
        <div>
            <div className="menu-header"/>
            <div className="menu-header2"/>
            <nav className={"navbar navbar-expand-md navbar-light bg-light ng-scope"}>
                <NavLink to={"/"} className="navbar-brand text-color" style={{letterSpacing: "0.5rem"}}>{t("app.name")}</NavLink>
                <ul className="nav navbar-nav ms-auto h4 menu-text desktop">
                    {[
                        ["/", t("home")], // prettier-ignore
                        ["/platform", t("platform")], // prettier-ignore
                        ["/parts", t("parts")], // prettier-ignore
                        ["/news", t("news")], // prettier-ignore
                        ["/blogs", t("blogs")], // prettier-ignore
                        // ["/tarifs", t("tarifs")], // prettier-ignore
                        ["/ai", t("ai")], // prettier-ignore
                        ["/services", t("services")], // prettier-ignore
                        // ["/hire", t("hire")], // prettier-ignore
                        ["/support", t("support")], // prettier-ignore
                        ["/documents", t("documents")], // prettier-ignore
                        ["/video", t("video")], // prettier-ignore
                    ].map(([path, text], i) => (
                        <li className="nav-item active me-2" key={i}>
                            <NavLink className={"nav-link "} to={path}>
                                {text}
                            </NavLink>
                        </li>
                    ))}
                    <li className="nav-item active" style={{marginRight: "-1rem"}}>
                        <a
                            className={"nav-link lang"}
                            onClick={(e) => funcLang(e as any, "ru")}
                            href="/"
                            id="ru"
                        >
                            RU
                        </a>
                    </li>
                    <li className="nav-item active me-2">
                        <a
                            className={"nav-link lang"}
                            onClick={(e) => funcLang(e as any, "en")}
                            href="/"
                            id="en"
                        >
                            EN
                        </a>
                    </li>
                    <li className="nav-item active">
                        <NavLink
                            className={"nav-link download rounded-pill "}
                            to="/download"
                            style={{color: "#FFFFFF"}}
                        >
                            {t("downloadBtn")}
                        </NavLink>
                    </li>
                </ul>
                <ul className="mobile nav navbar-nav ms-auto h4 menu-text">
                    <li className="nav-item active" style={{marginRight: "-1rem"}}>
                        <a
                            className={"nav-link lang"}
                            onClick={(e) => funcLang(e as any, "ru")}
                            href="/"
                            id="ru"
                        >
                            RU
                        </a>
                    </li>
                    <li className="nav-item active">
                        <a
                            className={"nav-link lang"}
                            onClick={(e) => funcLang(e as any, "en")}
                            href="/"
                            id="en"
                        >
                            EN
                        </a>
                    </li>
                    <li className="nav-item" style={{zIndex: 10000}}>
                        <MobileMenu isShown={isMobileShown} setIsShown={setIsMobileShown}/>
                    </li>
                </ul>
            </nav>
            <Row>
                <Col xs="8" xxl="8" lg="8">
                    {i18n.language === "ru" ? (
                        // <div className="d-flex flex-row-reverse header-main-container">
                        <div className="header-main-container">
                            <a target="_blank" rel="noreferrer" href="https://reestr.digital.gov.ru/reestr/490587/">
                                Аккредитация Минцифры №12352 от 21.12.2021
                            </a>
                        </div>
                    ) : ""}
                    <div className="header-main-container">
                        {/*<Button variant="secondary" onClick={() => setShowModal(true)}>*/}
                        {/*    {t('menu.make.order')}*/}
                        {/*</Button>*/}
                        {/*<a target="_blank" rel="noreferrer" className="text-dark my-font-weight-bold" href="https://t.me/Busines09575Bot">*/}
                        {/*    {t('menu.make.order')}*/}
                        {/*</a>*/}
                        <NavLinkR className="other text-dark my-font-weight-bold" href=""
                                  onClick={(e) => {
                                      e.preventDefault();
                                      setShowModal(true);
                                  }}>
                            {t('menu.make.order')}
                        </NavLinkR>
                        <ContactModal type={'MENU'} show={showModal} onHide={() => setShowModal(false)}/>
                    </div>
                </Col>
                <Col>
                    <div className="ya-site-form ya-site-form_inited_no"
                         data-bem="{&quot;action&quot;:&quot;https://yandex.ru/search/site/&quot;,&quot;arrow&quot;:false,&quot;bg&quot;:&quot;transparent&quot;,&quot;fontsize&quot;:12,&quot;fg&quot;:&quot;#000000&quot;,&quot;language&quot;:&quot;ru&quot;,&quot;logo&quot;:&quot;rb&quot;,&quot;publicname&quot;:&quot;Yandex Site Search #12946628&quot;,&quot;suggest&quot;:true,&quot;target&quot;:&quot;_blank&quot;,&quot;tld&quot;:&quot;ru&quot;,&quot;type&quot;:2,&quot;usebigdictionary&quot;:true,&quot;searchid&quot;:12946628,&quot;input_fg&quot;:&quot;#000000&quot;,&quot;input_bg&quot;:&quot;#ffffff&quot;,&quot;input_fontStyle&quot;:&quot;normal&quot;,&quot;input_fontWeight&quot;:&quot;normal&quot;,&quot;input_placeholder&quot;:null,&quot;input_placeholderColor&quot;:&quot;#000000&quot;,&quot;input_borderColor&quot;:&quot;#7f9db9&quot;}">
                        <form action="https://yandex.ru/search/site/" method="get" target="_blank" acceptCharset="utf-8">
                            <input type="hidden" name="searchid" defaultValue="12946628"/>
                            <input type="hidden" name="l10n" defaultValue="ru"/>
                            <input type="hidden" name="reqenc" defaultValue=""/>
                            <input type="search" name="text" defaultValue=""/>
                            <input type="submit" defaultValue="Найти"/>
                        </form>
                    </div>
                </Col>
                <Col>
                </Col>
            </Row>
        </div>
    );
};
